import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./users.module.css";
import ModalUsers from './modalUsers';
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';



const customStyles = {
    headRow: {
      style: {
        minHeight: "40px",
        backgroundColor: "#046cc2",
        fontSize:"15px",
        color:"white",
      },
    },
    
    
  };
const customStyles3 = {
    table: {
        style: {
          borderRadius: '0px', 
        },   
    },
	rows: {
		style: {
            borderRadius:"0px",
            backgroundColor:"#e0e0e0"
		},
	},
	headCells: {
		style: {
            borderRadius:"0px",
            fontSize:"17px",
            color:"white",
            backgroundColor:"#046cc2"
		},
	},
	cells: {
		style: {
			
		},
	},
};
let dataTemp = [
    {
        counter:1,
        name:"Irvin",
        lastName:"Flores",
        rol:"ADMINISTRADOR",
        userName:"irvin316",
        email:"alex316123@gmail.com"
    }
]
export default function Users(props) {
    const { windowSize,estados,municipios } = useAuth();

    const [showModal,setShowModal] = useState(false);
    const [dataTable,setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [asesores,setAsesores] = useState([]);

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
        },
        {
            name: 'Nombre',
            selector: row => row.lastName+" "+row.firstName,
        },
        {
            name: 'Rol',
            selector: row => row.rol,
        },
        {
            name: 'Usuario',
            selector: row => row.userName,
        },
        {
            name: 'Email',
            selector: row => row.email,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={()=>{setUserEdit(row);setShowModal(true);}}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={()=>handleDelete(row.userName,row.id)}><MdDelete /></button>
                    </div>
                )
            },
        }
    ];
    
    const handleDelete = (userName,userId)=>{
        Swal.fire({
            title: "Esta segur@ que desea eliminar el usuario "+userName+"?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let payload = {
                    userName:userName
                }
                api(SERVICE.deleteUser+`?UsersId=${userId}`,{},"DELETE")
                .then((data)=>{
                  handleUpdate();
                })
                .catch((err)=>{
                  console.log(err);
                })
            }
          });
        
    }
    const handleUpdate = ()=>{
        api(SERVICE.getUser)
        .then((data)=>{
          let arrayTemp = [];
          if(data.data.data){
            for (let index = 0; index < data.data.data.length; index++) {
                const element = data.data.data[index];
                let searchIndexRol = roles.findIndex(item=>item.id === element.roleId);
                let roleName = "";
                if(searchIndexRol!=-1){
                    roleName = roles[searchIndexRol].description;
                }
                arrayTemp.push({
                    rol:roleName,
                    ...element
                })
                
              }
          }
          setDataTable(arrayTemp);
        })
        .catch((err)=>{
          console.log(err);
        })
    }
    const handleUpdateRoles = () => {

        api(SERVICE.getRoles)
            .then((data) => {
                let arrayTemp = [];
                for (let index = 0; index < data.data.data.length; index++) {
                    const element = data.data.data[index];
                    arrayTemp.push({
                        id: element.id,
                        identifier: element.identifier,
                        description: element.description
                    })
                }
                setRoles(arrayTemp);
            })
            .catch((err) => {

            })
    }
    const handleGetAsesortes = () => {
        api(SERVICE.getAsesoresAll)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.completeName
                        });
                    }
                }
                setAsesores(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    useEffect(()=>{
        handleUpdateRoles();
        handleGetAsesortes();
    },[])
    useEffect(()=>{
        if(roles.length>0){
            handleUpdate();
        }
    },[roles])
    return (
        <>
            <WindowLayout
                title = "USUARIOS"
                route={["Configuración","Usuarios"]}
                icon = {<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={()=>setShowModal(!showModal)}><FaPlus /></button>
                    </div>
                    
                  
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                    />
                    
                </div>
            </WindowLayout>
            <ModalUsers
                show = {showModal}
                setShow = {setShowModal}
                handleUpdate = {handleUpdate}
                roles = {roles}
                dataEdit = {userEdit}
                setDataEdit = {setUserEdit}
                estados = {estados}
                municipios = {municipios}
                asesores = {asesores}
            />
        </>
    );
} 